<template>
  <div class="container-fluid-intropage">
    <div class="container-fluid p-0 cover-story">
      <img src="/especiales/noticias/2023/fernandovalenzuela/images/cover-toro-valenzuela3.jpg" alt="" width="100%">
    </div>
    <div class="container-meta">
      <div class="container pt-3 pb-3">
        <div class="row justify-content-center">
          <div class="col-12 col-md-9 text-center">
            <div class="mb-3">
              <img width="200px" src="@/assets/pride.png" alt="">
            </div>
            <h1 class="name">Fernando Valenzuela, el brazo que conquistó una generación</h1>
            <div class="description">
              <h2 class="description__title" style="text-align:left;"> <p>El pitcher mexicano fue un ídolo en México y para los millones de migrantes en el sur de Estados Unidos durante la década de los 80.</p>
<p>Tras dejar Navojoa, un pueblo de no más de 1,000 habitantes, conquistó las Grandes Ligas jugando para los Dodgers con el número 34 en su camiseta. Hoy Valenzuela es considerado todo un fenómeno cultural.</p>
<p>Esta es su historia.</p></h2>
            </div>
            <div class="mt-3">
              <SharingOptions />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  .container-fluid-intropage {
    position: relative;
    background:  #000000;

    .cover-story {
      width: 100%;
      overflow: hidden;

      img {
        width: 100%;
        height: auto;
        min-height: 100vh;
        object-fit: cover;
        object-position: top;

        @media(max-width:560px){
          height: 45vh;
          min-height: 45vh;
          max-height: 45vh;
        }
      }
    }
  }

  .container-meta {
    position: absolute;
    width: 100%;
    bottom: 0;

    @media(max-width:560px){
      position: relative;
    }
  }
</style>

<script>
  import SharingOptions from '@/components/SharingOptions.vue';

	export default {
    name: "IntroPage",
    components: {
      SharingOptions
    }
  }
</script>